"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const jsonpath_1 = __importDefault(require("jsonpath"));
const luxon_1 = require("luxon");
const _1 = require(".");
const api_fact_1 = require("./api-fact");
function getChildValue(obj, path) {
    if (!path) {
        return obj;
    }
    if (!path.startsWith('$')) {
        // Turn it into a json path, assuming the input path is the name of a
        // direct child.
        path = '$.' + path;
    }
    return jsonpath_1.default.value(obj, path);
}
function asArray(value) {
    return (0, lodash_1.isArray)(value) ? value : [value];
}
async function sum(params, almanac) {
    const value = await almanac.factValue(params.fact);
    if (!value) {
        return 0;
    }
    const valueArray = asArray(value);
    return (0, lodash_1.sumBy)(valueArray, (item) => Number(getChildValue(item, params.path)) || 0);
}
async function project(params, almanac) {
    const value = await almanac.factValue(params.fact);
    if (!value) {
        return [];
    }
    if ((0, lodash_1.isArray)(value)) {
        return (0, lodash_1.map)(value, (item) => {
            return getChildValue(item, params.path);
        });
    }
    else {
        return getChildValue(value, params.path);
    }
}
async function date(params, almanac) {
    const timezone = await almanac.factValue((0, _1.internalFact)('timezone'));
    // If timezone is undefined it will default
    // to the system zone.
    let date = luxon_1.DateTime.now().setZone(timezone);
    if (params.value) {
        const dateString = typeof params.value === 'string'
            ? params.value
            : await almanac.factValue(params.value.fact, params.value.params, params.value.path);
        // If timezone is undefined it will default to the system zone.
        date = luxon_1.DateTime.fromISO(String(dateString), { zone: timezone });
    }
    if (params.offset) {
        date = date.plus({
            years: params.offset.years,
            months: params.offset.months,
            days: params.offset.days,
        });
    }
    return date.toISODate();
}
const facts = {
    sum,
    project,
    date,
    api: api_fact_1.api,
};
exports.default = facts;
//# sourceMappingURL=facts.js.map